import React, { useEffect, useReducer, useState } from 'react';
import {
  AutocompleteComponent,
  Inputs,
  SelectComponet,
} from '../../../../../../Components';
import { GetAllEntitySources } from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import { entitySourcesOptions } from '../../../Utilities/Utilities';
import { showError } from '../../../../../../Helper';
import { lookupItemsGetId } from '../../../../../../Services';
import { StaticLookupsIds } from '../../../../../../assets/json/StaticLookupsIds';
import { SearchIcon, UserOneIcon } from '../../../../../../assets/icons';
import { useDebouncedAction } from '../../../../../../Hooks/DebouncedAction';
import { DateRangePickerComponent } from '../../../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';
import moment from 'moment';
import { useLeadXchangeData } from '../Context/LeadXchangeData';

const reducer = (state, action) => {
  if (action.id !== 'edit') return { ...state, [action.id]: action.value };
  return {
    ...action.value,
  };
};
export default function LeadXChangeLeadFilter({ setFilter, filter, key }) {
  const { actionableItems, setActionableItems } = useLeadXchangeData();
  const [data, setData] = useState({
    entitySources: [],
    languages: [],
    nationalities: [],
    Community: [],
    Cities: [],
    District: [],
  });

  const [loading, setLoading] = useState({
    Languages: false,
    nationality: false,
    Community: false,
  });

  const [selected, setSelected] = useReducer(reducer, {
    City: null,
    District: null,
    Community: null,
  });
  const debouncedSetFilterData = useDebouncedAction(setFilter);

  const getAllEntitySources = async () => {
    try {
      const res = await GetAllEntitySources();
      setData((prev) => ({ ...prev, entitySources: res }));
    } catch (error) {
      showError('something-went-wrong');
    }
  };

  const getLanguages = async () => {
    setLoading((prev) => ({ ...prev, languages: true }));
    const res = await lookupItemsGetId({
      lookupTypeId: StaticLookupsIds.Languages,
    });
    if (!(res && res.status && res.status !== 200))
      setData((prev) => ({ ...prev, languages: res }));
    else setData((prev) => ({ ...prev, languages: [] }));
    setLoading((prev) => ({ ...prev, languages: false }));
  };

  const getNationalities = async () => {
    setLoading((prev) => ({ ...prev, nationality: true }));
    const res = await lookupItemsGetId({
      lookupTypeId: StaticLookupsIds.Country,
    });
    if (!(res && res.status && res.status !== 200))
      setData((prev) => ({ ...prev, nationalities: res }));
    else setData((prev) => ({ ...prev, nationalities: [] }));
    setLoading((prev) => ({ ...prev, nationality: false }));
  };

  const getAddressLookupsById = async (lookupTypeName, lookupParentId) => {
    setLoading((prev) => ({ ...prev, lookupTypeName: true }));
    const response = await lookupItemsGetId({
      lookupTypeId: StaticLookupsIds[lookupTypeName],
      lookupParentId,
    });
    if (!(response && response.status && response.status !== 200)) {
      setData((prev) => ({ ...prev, [lookupTypeName]: response || [] }));
    }
    setLoading((prev) => ({ ...prev, lookupTypeName: false }));
  };

  const autoFillLocationHandler = (locationKey, locationValue) => {
    const autoFilledLocation = {};

    const lookupItemParents = JSON.parse(
      locationValue?.lookupItemParents || '[]'
    );

    lookupItemParents.forEach((item) => {
      autoFilledLocation[item.LookupType] = {
        lookupItemId: item.LookupItemId,
        lookupItemName: item.LookupItemName,
      };
    });

    setSelected({
      id: 'edit',
      value: {
        City: null,
        District: null,
        Community: null,
        ...autoFilledLocation,
        [locationKey]: locationValue,
      },
    });
    const autoFilledLocationFilter = {};
    for (const key in autoFilledLocation) {
      const lowerCaseKey = key.toLowerCase();
      autoFilledLocationFilter[lowerCaseKey] =
        autoFilledLocation[key]?.lookupItemName;
    }
    setFilter((prev) => ({
      ...prev,
      [locationKey.toLowerCase()]: locationValue.lookupItemName,
      ...autoFilledLocationFilter,
    }));
  };

  useEffect(() => {
    getAllEntitySources();
  }, []);

  return (
    <div
      key={key}
      className='filter-section-proposalLog'
    >
      <div className='filter-left-section-proposalLog'>
        <AutocompleteComponent
          idRef='EntityNameRef'
          data={data.entitySources}
          inputPlaceholder='Entity name'
          wrapperClasses='styledAutoComplete'
          multiple={false}
          chipsLabel={(option) => option?.entitySourceName}
          displayLabel={(option) => option?.entitySourceName}
          filterOptions={(options) =>
            options.filter((option) =>
              entitySourcesOptions.includes(option.entitySourceName)
            )
          }
          onChange={(_, newValue) => {
            setFilter((prev) => ({
              ...prev,
              leadExchangePoolSource: {
                sourceId: newValue?.entitySourceId,
                sourceName: newValue?.entitySourceName,
              },
            }));
          }}
          withoutSearchButton
          inputClasses='fields-content'
        />
        <AutocompleteComponent
          idRef='LanguageRef'
          isLoading={loading.Languages}
          inputClasses='fields-content'
          wrapperClasses='styledAutoComplete'
          inputPlaceholder='Languages'
          data={data.languages || []}
          multiple={false}
          chipsLabel={(option) => option?.lookupItemName || ''}
          displayLabel={(option) => option?.lookupItemName || ''}
          withoutSearchButton
          onOpen={() => {
            if (data.languages?.length === 0) getLanguages();
          }}
          onChange={(_, newValue) => {
            setFilter((prev) => ({
              ...prev,
              language: newValue?.lookupItemName,
            }));
          }}
        />
        <AutocompleteComponent
          idRef='nationalityRef'
          isLoading={loading.nationality}
          inputPlaceholder='Nationality'
          inputClasses='fields-content'
          wrapperClasses='styledAutoComplete'
          data={data.nationalities}
          multiple={false}
          chipsLabel={(option) => option?.lookupItemName || ''}
          displayLabel={(option) => option?.lookupItemName || ''}
          withoutSearchButton
          onOpen={() => {
            if (data.nationalities?.length === 0) getNationalities();
          }}
          onChange={(_, newValue) => {
            setFilter((prev) => ({
              ...prev,
              nationality: newValue?.lookupItemName,
            }));
          }}
        />
        <AutocompleteComponent
          idRef='CommunitiesIdRef'
          inputPlaceholder='Community'
          inputClasses='fields-content'
          wrapperClasses='styledAutoComplete'
          selectedValues={selected.Community}
          multiple={false}
          data={data.Community}
          isLoading={loading.Community}
          onOpen={() => {
            const districtId = selected.District?.lookupItemId;
            if (districtId) getAddressLookupsById('Community', districtId);
            else getAddressLookupsById('Community');
          }}
          displayLabel={(option) => option.lookupItemName || ''}
          withoutSearchButton
          isWithError
          onChange={(_, newValue) => {
            if (newValue) autoFillLocationHandler('Community', newValue);
            else {
              setSelected({
                id: 'edit',
                value: {
                  ...selected,
                  Community: null,
                  City: null,
                  District: null,
                  Country: null,
                },
              });
              setFilter((prev) => ({
                ...prev,
                community: null,
                city: null,
                district: null,
                country: null,
              }));
            }
          }}
        />
        <AutocompleteComponent
          idRef='cityFilterRef'
          inputPlaceholder={'City'}
          wrapperClasses='styledAutoComplete'
          selectedValues={selected.City}
          inputClasses='fields-content'
          multiple={false}
          data={data.Cities}
          isLoading={loading.City}
          displayLabel={(option) => option.lookupItemName || ''}
          withoutSearchButton
          isWithError
          onOpen={() => {
            const countryId = selected.Country?.lookupItemId;
            if (countryId) getAddressLookupsById('Cities', countryId);
            else getAddressLookupsById('Cities');
          }}
          onChange={(_, newValue) => {
            if (newValue) autoFillLocationHandler('City', newValue);
            else {
              setSelected({
                id: 'edit',
                value: {
                  ...selected,
                  City: null,
                  District: null,
                  Community: null,
                  Country: null,
                },
              });
              setFilter((prev) => ({
                ...prev,
                city: null,
                district: null,
                community: null,
                country: null,
              }));
            }
          }}
        />
        <AutocompleteComponent
          idRef='districtIdRef'
          inputPlaceholder={'District'}
          inputClasses='fields-content'
          wrapperClasses='styledAutoComplete'
          selectedValues={selected.District}
          multiple={false}
          data={data.District}
          isLoading={loading.District}
          onOpen={() => {
            const cityId = selected.City?.lookupItemId;
            if (cityId) getAddressLookupsById('District', cityId);
            else getAddressLookupsById('District');
          }}
          displayLabel={(option) => option.lookupItemName || ''}
          withoutSearchButton
          isWithError
          onChange={(_, newValue) => {
            if (newValue) autoFillLocationHandler('District', newValue);
            else {
              setSelected({
                id: 'edit',
                value: {
                  ...selected,
                  District: null,
                  Community: null,
                  City: null,
                  Country: null,
                },
              });
              setFilter((prev) => ({
                ...prev,
                city: null,
                district: null,
                community: null,
                country: null,
              }));
            }
          }}
        />
        <Inputs
          idRef='ContactNameRef'
          inputPlaceholder='Contact name'
          wrapperClasses='w-25 px-1'
          onInputChanged={(event) => {
            event.persist();
            const { value } = event.target;
            debouncedSetFilterData((prev) => ({
              ...prev,
              contactName: value,
            }));
          }}
          fieldClasses='fields-content'
          startAdornment={
            <UserOneIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        <Inputs
          idRef='LeadRef'
          inputPlaceholder='Lead ID'
          wrapperClasses='w-25 px-1'
          onInputChanged={(event) => {
            event.persist();
            const { value } = event.target;
            debouncedSetFilterData((prev) => ({
              ...prev,
              crmLeadId: value,
            }));
          }}
          fieldClasses='fields-content'
          startAdornment={
            <SearchIcon
              width='24'
              height='24'
              fill='#8E8E93'
            />
          }
        />
        {actionableItems.action && (
          <SelectComponet
            data={[
              { id: 3, name: 'Buyer' },
              { id: 4, name: 'Tenant' },
            ]}
            valueInput='id'
            textInput='name'
            placeholder='type'
            emptyItem={{
              value: null,
              text: 'Select Type ',
              isDisabled: false,
            }}
            value={filter.leadClass?.id}
            onSelectChanged={(value) => {
              setFilter((prev) => ({
                ...prev,
                leadClass: {
                  id: value,
                  name: value === 3 ? 'Buyer' : 'Tenant',
                },
              }));
            }}
            wrapperClasses='fields-content w-auto px-1'
          />
        )}
      </div>
      <div className='filter-right-section-proposalLog w-25'>
        <div className='w-100'>
          <DateRangePickerComponent
            idRef='DateRef'
            placeholder='DD/MM/YYYY'
            ranges={[
              {
                startDate: filter.sharedDateFrom,
                endDate: moment(filter.sharedDateTo),
                key: 'selection',
              },
            ]}
            onClearClicked={() =>
              setFilter((prev) => ({
                ...prev,
                sharedDateFrom: null,
                sharedDateTo: null,
              }))
            }
            onDateChanged={(e) => {
              setFilter((prev) => ({
                ...prev,
                sharedDateFrom: new Date(
                  moment(e.selection.startDate).endOf('day')
                ),
                sharedDateTo: new Date(
                  moment(e.selection.endDate).endOf('day')
                ),
              }));
            }}
            wrapperClasses='w-100 styled-data-picker '
          />
        </div>
      </div>
    </div>
  );
}
